import { useContext } from "react";
import { ColyseusContext } from "@/contexts/ColyseusContext.js";

export function useColyseus() {
  return useContext(ColyseusContext);
}
